import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { createRoot } from 'react-dom/client';
import { initReactI18next } from 'react-i18next';
import de from '../assets/locales/de/translation.json';
import en from '../assets/locales/en/translation.json';
import App from './App';
import './index.css';
import SelectionContextProvider from './SelectionContext';
import ThemeContextProvider from './ThemeContext';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    load: 'languageOnly',
    nsSeparator: ';',
    // Part of the hashed script: a browser can no longer pair a cached translation file of an older build with a
    // newer script, which showed raw keys such as "discovery.roles.theme" instead of the texts.
    resources: { de: { translation: de }, en: { translation: en } },
    supportedLngs: ['en', 'de']
  });

createRoot(document.getElementById('app')).render(
  <ThemeContextProvider>
    <SelectionContextProvider>
      <App />
    </SelectionContextProvider>
  </ThemeContextProvider>
);
